import { render, staticRenderFns } from "./DocumentsGrid.vue?vue&type=template&id=0b6e5f47"
import script from "./DocumentsGrid.vue?vue&type=script&lang=js"
export * from "./DocumentsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports